import { COLORS } from '@/utils/colors';
import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
  size = 'medium',
  className = ''
}) => {
  const spinnerSizes = {
    small: 'h-6 w-6',
    medium: 'h-12 w-12',
    large: 'h-16 w-16'
  };

  const textSizes = {
    small: 'text-sm',
    medium: 'text-base',
    large: 'text-lg'
  };

  return (
    <div className={`flex flex-col items-center justify-center min-h-[200px] ${className}`}>
      <div
        style={{ borderColor: COLORS.primary }}
        className={`animate-spin rounded-full border-t-2 border-b-2 border-blue-500 ${spinnerSizes[size]}`}></div>
      {message && (
        <p
          style={{ color: COLORS.black }}
          className={`mt-4  ${textSizes[size]}`}>{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner; 